<template>
  <div class="login-container">
    <!-- 顶部区域 -->
    <div class="top-section">
      <img src="../../assets/login/yblogo@2x.png" alt="logo" class="top-logo">
    </div>

    <!-- 中间登录区域 -->
    <div class="middle-section">
      <div class="login-form-container">
        <!-- 第一步：验证手机号 -->
        <div v-if="currentStep === 1">
          <div class="login-title">验证手机号</div>
          <div class="form-group">
            <label class="form-label" style="margin-bottom: 10px">手机号</label>
            <div class="verify-code-container">
              <input class="form-input" type="text" placeholder="请输手机号" v-model="uname"/>
            </div>
          </div>
          <div class="form-group">
             <label class="form-label" style="margin-bottom: 10px">验证码</label>
            <div class="verify-code-container">
              <input class="form-input verify-input" type="text" placeholder="请输入短信验证码" v-model="verify_code"/>
              <button class="send-sms-btn" @click="sendSmsCode" :disabled="smsCountdown > 0">
                {{ smsCountdown > 0 ? `${smsCountdown}s后重发` : '发送验证码' }}
              </button>
            </div>
          </div>
          <button class="login-button" @click="nextStep">下一步</button>
          <button class="email-activate-button" v-if="email_check_show" @click="email_check">邮箱激活</button>
        </div>

        <!-- 第二步：设置密码 -->
        <div v-if="currentStep === 2">
          <div class="login-title">设置密码</div>
          <div class="form-group">
            <label class="form-label" style="margin-bottom: 10px">密码</label>
            <div class="verify-code-container">
              <input class="form-input" type="password" placeholder="请输入新密码" v-model="newPassword"/>
            </div>

          </div>
          <div class="form-group">
            <label class="form-label" style="margin-bottom: 10px">确认密码</label>
            <div class="verify-code-container">
              <input class="form-input" type="password" placeholder="请两次确认密码" v-model="confirmPassword"/>
            </div>

          </div>
          <button class="login-button" @click="completeReset">完成</button>
        </div>

        <div class="login-links">
          <span class="forgot-password" @click="to_index">返回首页</span>
          <span class="register-link" @click="to_login">登录</span>
        </div>
      </div>
    </div>

    <!-- 底部区域 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-top">
            <div class="footer-left">
              <div class="qr-item">
            <img class="qr-img" src="../../assets/index/jszc_qr.png" alt="技术支持二维码"/>
            <div class="qr-caption">技术支持</div>
          </div>
              <div class="qr-item">
            <img class="qr-img" src="../../assets/index/swhz_qr.png" alt="商务合作二维码"/>
            <div class="qr-caption">商务合作</div>
          </div>
            </div>
            <div class="footer-right">
              <img alt="b_yb_logo" class="b_yb_logo" src="../../assets/index/db_logo.png">
            </div>


          </div>
          <div class="footer-bottom">
            <div class="footer-left">
              <router-link to="/privacy" class="footer-link">隐私条款</router-link>
              <router-link to="/risk" class="footer-link">风险提示</router-link>
              <router-link to="/disclaimer" class="footer-link">免责条款</router-link>
            </div>
            <div class="footer-right">
              <p class="copyright">
                Copyright&nbsp;&nbsp;©&nbsp;&nbsp;2025&nbsp;&nbsp;悦宝金服-上海悦宝互联网金融信息服务股份有限公司</p>
              <p class="disclaimer">本网站不提供任何投资咨询服务、投资顾问服务、投资理财服务</p>
              <p class="copyright"><a href="https://beian.miit.gov.cn/"
                                      style="text-decoration: none;color: inherit"
                                      target="_blank">沪ICP备17003327号-1</a></p>

            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>

</template>

<script>
  import {ElMessage} from "element-plus";
  import {menu_limits, asyncRoutes, addRouter, setupRouter} from "@/router";

  import {
    fgt_pwd_change,send_reset_pwd_sms,sms_check
  } from "@/api/system/system.js";



  import {getCurrentInstance} from "vue";
  // 引入图片验证码组件
  import VerifyCode from "@/components/VerifyCode/verifyCode.vue";

  export default {
    components: {VerifyCode},
    data() {
      return {
        zx_qr_show: false,
        email_check_show: false,
        uname: "",
        upwd: "",
        verify_code: "",
        VerifyCodeStr: "",
        VerifyCodeImg: "",
        smsCountdown: 0,
        smsTimer: null,
        conf: {
          version: getCurrentInstance()?.appContext.config.globalProperties
            .$g_version,
        },
        url: "",
        loginCode: undefined,
        // 添加步骤状态管理
        currentStep: 1, // 1: 验证手机号, 2: 设置密码
        newPassword: "",
        confirmPassword: "",
      };
    },
    mounted() {
      // 判断是否携带token 如果携带token 调用邮箱token验证接口
      if (this.$route.query.token) {
        var data = {
          "token": this.$route.query.token
        };
        sys_acount_verify(data).then(
          (res) => {
            if (res.data.meta.success === true) {
              ElMessage({
                showClose: true,
                message: "账户激活成功",
                type: "success",
              });
            } else {
              ElMessage({
                showClose: true,
                message: "账户激活失败，请登录账号激活",
                type: "error",
              });
            }

          },
          (error) => {
            console.log(error);
            ElMessage({
              showClose: true,
              message: "账户激活失败，请登录账号激活",
              type: "error",
            });
          }
        );

      }

      // 清空 sessionStorage 防止通过回退绕过登陆
      sessionStorage.clear();
      // 重置锁屏状态
      this.$store.dispatch("UnLockScreen");

      this.$store.dispatch("setVisitedTab", "");

      let xoc_account = localStorage.getItem("xoc_account", this.uname);
      if (xoc_account) {
        this.uname = xoc_account;
        this.checked = true;
      }

      console.log("--------loginCode----", this.loginCode);
      this.loginCode = this.$route.query.code;

      // this.updateVerifyCode();

      localStorage.setItem('lastClickTime', 0);
    },

    watch: {

      $route: {
        handler(route) {
          this.loginCode = undefined;
          this.redirect = (route.query && route.query.redirect) || "/";
        },
        immediate: true,
      },
    },
    methods: {
      zxMouseOver() {
        this.zx_qr_show = true;
      },
      zxMouseOut() {
        this.zx_qr_show = false;
      },
      to_login() {
        this.$router.push("/Login");
      },
      to_index() {
        this.$router.push("/index");
      },



      // 发送短信验证码
      sendSmsCode() {
        if (!this.uname) {
          ElMessage({
            showClose: true,
            message: "请输入手机号",
            type: "warning",
          });
          return;
        }

        // 验证手机号格式
        const phoneRegex = /^1[3-9]\d{9}$/;
        if (!phoneRegex.test(this.uname)) {
          ElMessage({
            showClose: true,
            message: "请输入正确的手机号格式",
            type: "warning",
          });
          return;
        }

        // 这里应该调用发送短信验证码的API
        var data = {
          "tel_num":this.uname
        }
        send_reset_pwd_sms(data).then(
          (res) => {
            // console.log("==send_reset_pwd_sms==", res );
            if (res.data.code === 0) {
              ElMessage({
                showClose: true,
                message: "验证码已发送",
                type: "success",
              });


            } else {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }

          },
          (error) => {
            console.log(error);
            ElMessage({
              showClose: true,
              message: "验证码发送失败",
              type: "error",
            });
          }
        );
        // 开始倒计时
        this.startCountdown();
      },

      // 开始倒计时
      startCountdown() {
        this.smsCountdown = 60;
        this.smsTimer = setInterval(() => {
          this.smsCountdown--;
          if (this.smsCountdown <= 0) {
            clearInterval(this.smsTimer);
            this.smsTimer = null;
          }
        }, 1000);
      },

      // 下一步按钮点击事件
      nextStep() {
        // 验证手机号和验证码
        if (!this.uname) {
          ElMessage({
            showClose: true,
            message: "请输入手机号",
            type: "warning",
          });
          return;
        }

        // 验证手机号格式
        const phoneRegex = /^1[3-9]\d{9}$/;
        if (!phoneRegex.test(this.uname)) {
          ElMessage({
            showClose: true,
            message: "请输入正确的手机号格式",
            type: "warning",
          });
          return;
        }

        if (!this.verify_code) {
          ElMessage({
            showClose: true,
            message: "请输入验证码",
            type: "warning",
          });
          return;
        }

        // 这里可以添加验证码验证逻辑
        var data = {
          "tel_num":this.uname,
          "verify_code":this.verify_code,
        }
        sms_check(data).then(
          (res) => {
            console.log("==sms_check==", res );
            if (res.data.code === 0) {
               // 验证通过后切换到下一步
              this.currentStep = 2;

            } else {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }

          },
          (error) => {
            console.log(error);
            ElMessage({
              showClose: true,
              message: "验证码验证失败",
              type: "error",
            });
          }
        );


      },

      // 完成按钮点击事件
      completeReset() {
        // 验证密码
        if (!this.newPassword) {
          ElMessage({
            showClose: true,
            message: "请输入新密码",
            type: "warning",
          });
          return;
        }

        if (this.newPassword.length < 6) {
          ElMessage({
            showClose: true,
            message: "密码长度不能少于6位",
            type: "warning",
          });
          return;
        }

        if (!this.confirmPassword) {
          ElMessage({
            showClose: true,
            message: "请确认密码",
            type: "warning",
          });
          return;
        }

        if (this.newPassword !== this.confirmPassword) {
          ElMessage({
            showClose: true,
            message: "两次输入的密码不一致",
            type: "warning",
          });
          return;
        }

        // 这里可以添加密码重置的API调用
        var data_parm = {
          phone_numbers: this.uname,
          verify_code: this.verify_code,
          new_password: this.newPassword
        };

        fgt_pwd_change(data_parm).then(
            (res) => {
              console.log("==fgt_pwd_change==",res.data);
              if (res.data.code === 0) {
                ElMessage({
                  showClose: true,
                  message: "密码重置成功",
                  type: "success",
                });
                // 重置成功后跳转到登录页面
                this.$router.push("/Login");


              }
              else {
                ElMessage({
                  showClose: true,
                  message: res.data.msg,
                  type: "error",
                });
              }



            },
            (error) => {
              if (error.toString().includes('403')) {
                ElMessage({
                  showClose: true,
                  message: "密码重置失败!",
                  type: "warning",
                });

              } else {
                ElMessage({
                  showClose: true,
                  message: error,
                  type: "warning",
                });
              }

            }
        );




      }

    },
    beforeUnmount() {
      // 清理定时器
      if (this.smsTimer) {
        clearInterval(this.smsTimer);
        this.smsTimer = null;
      }
    }
  };
</script>
<style scoped>
  /* 主容器 */
  .login-container {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: "PingFang", sans-serif;
  }

  /* 顶部区域 */
  .top-section {
    height: 78px;
    width: 100%;
    background-color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }

  .top-logo {
    height: 30px;
    width: 140px;
  }

  /* 中间登录区域 */
  .middle-section {
    flex: 1;
    background-image: url(../../assets/login/login_bg@2x.png);
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login-form-container {
    width: 300px;
    background-color: #FFFFFF;
    border-radius: 4px;
    padding: 20px 40px 20px 40px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }

  .login-title {
    text-align: center;
    color: #BA0B0B;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 30px;
  }

  .form-group {
    margin-bottom: 15px;
    position: relative;
    line-height: 1;
  }

  .form-label {
    display: block;
    color: #040404;
    font-size: 14px;
    margin-bottom: 0px;
    line-height: 1;
  }

  .form-input {
    width: 100%;
    height: 40px;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    padding: 0 12px;
    font-size: 14px;
    color: #040404;
    outline: none;
    box-sizing: border-box;
  }

  .form-input:focus {
    border-color: #BA0B0B;
  }

  .form-input::placeholder {
    color: #ADADAD;
  }

  .verify-code-container {
    display: flex;
    gap: 10px;
  }

  .verify-input {
    flex: 1;
  }

  .send-sms-btn {
    width: 120px;
    height: 40px;
    background-color: #BA0B0B;
    color: #FFFFFF;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    white-space: nowrap;
  }

  .send-sms-btn:hover:not(:disabled) {
    background-color: #A00A0A;
  }

  .send-sms-btn:disabled {
    background-color: #CCCCCC;
    cursor: not-allowed;
  }

  .login-button {
    width: 100%;
    height: 40px;
    background-color: #BA0B0B;
    color: #FFFFFF;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 20px;
  }

  .login-button:hover {
    background-color: #A00A0A;
  }

  .email-activate-button {
    width: 100%;
    height: 40px;
    background-color: #BA0B0B;
    color: #FFFFFF;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 20px;
  }

  .login-links {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .forgot-password {
    color: #777777;
    font-size: 14px;
    cursor: pointer;
  }

  .register-link {
    color: #BA0B0B;
    font-size: 14px;
    cursor: pointer;
  }

  .register-link:hover {
    text-decoration: underline;
  }

  /* 底部区域 */
  .bottom-section {
    height: 200px;
    background-color: #040404;

  }

  .bottom-row {
    height: 50%;
  }

  .bottom-right-cell {
    width: 40%;
    float: right;
    padding-right: 250px;
    text-align: right;
  }

  .bottom-left-cell {
    width: 30%;
    float: left;
    padding-left: 250px;
    line-height: 0;
  }




  .bottom-logo {
    height: 40px;
    width: auto;
    margin-top: 20px;
  }

  .privacy-link,
  .risk-link {
    color: #FFFFFF;
    font-size: 14px;
    cursor: pointer;
    margin-right: 30px;
    line-height: 0;
  }

  .privacy-link:last-child,
  .risk-link:last-child {
    margin-right: 0;
  }

  .privacy-link:hover,
  .risk-link:hover {
    text-decoration: underline;
  }

  .copyright-text {
    color: #FFFFFF;
    font-size: 14px;
    margin-bottom: 10px;
    text-align: right;
    line-height: 1;
  }

  .disclaimer-text {
    color: #FFFFFF;
    font-size: 14px;
    margin-bottom: 10px;
    text-align: right;
  }

  /* 客服相关样式 */
  .zx_mr_box {
    position: fixed;
    right: 40px;
    bottom: 200px;
    font-size: 100px;
    background-image: url(../../assets/index/zx-mr.png);
    background-size: 100% 100%;
    width: 54px;
    height: 54px;
  }

  .zx_xf_box {
    position: fixed;
    right: 40px;
    bottom: 200px;
    font-size: 100px;
    background-image: url(../../assets/index/zx-xf.png);
    background-size: 100% 100%;
    width: 54px;
    height: 54px;
  }

  .zx_qr_box {
    position: fixed;
    right: 120px;
    bottom: 150px;
    width: 100px;
    height: 120px;
    border: 10px solid white;
    background-color: white;
    color: #7E7E7E;
  }

  /* 清除浮动 */
  .form-group::after {
    content: "";
    display: table;
    clear: both;
  }

  /* 响应式设计 */
  @media (max-width: 768px) {
    .login-form-container {
      width: 90%;
      margin: 0 20px;
    }

    .bottom-section {
      padding: 0 20px;
      flex-direction: column;
      gap: 20px;
    }

    .bottom-left {
      order: 2;
    }

    .bottom-right {
      order: 1;
    }
  }


.footer {
  background-color: #000;
  padding: 30px 0;
  display: flex;
  align-items: center;
}

.footer .container {
  max-width: 100%;
  margin: 0 auto;
  padding: 0 15%;
  width: 100%;
}

.footer-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.footer-divider {
  height: 1px;
  background-color: #fff;
  opacity: 0.1;
  margin-bottom: 20px;
  margin-top: 35px;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: unset;
}

.footer-left {
  display: flex;
  gap: 30px;
  align-items: flex-end;
}

.footer-link {
  color: #999;
  text-decoration: none;
  font-size: 12px;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #C52133;
}

.footer-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.b_yb_logo {
  height: 30px;
  width: 140px;
  padding-bottom: 20px;

}

.copyright, .disclaimer {
  color: #999;
  font-size: 12px;
  margin: 0;
  line-height: 1.6;
}
.qr-item {
  text-align: center;
}

.qr-img {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.qr-caption {
  color: #999;
  font-size: 12px;
}


/* 响应式媒体查询 */
@media (max-width: 1200px) {
  .footer .container {
    padding: 0 10%;
  }

  .qr-img {
    width: 60px;
    height: 60px;
  }

  .qr-caption {
    font-size: 11px;
    position: absolute;
    width: 60px
  }
}

@media (max-width: 768px) {
  /* 顶部区域调整 */
  .top-section {
    height: 60px;
    padding: 10px;
  }

  .top-logo {
    height: 25px;
    width: 120px;
  }

  /* 登录表单容器 */
  .login-form-container {
    width: 90%;
    max-width: 340px;
    padding: 20px 30px;
  }

  .login-title {
    font-size: 18px;
  }

  /* 表单元素 */
  .form-label {
    font-size: 13px;
  }


  /* 按钮 */
  .login-button,
  .email-activate-button {
    height: 36px;
    font-size: 13px;
    margin-bottom: 15px;
  }

  .forgot-password,
  .register-link,
  .index_link {
    font-size: 13px;
  }

  /* Footer调整 */
  .footer {
    padding: 20px 0;
  }

  .footer .container {
    padding: 0 5%;
  }

  .footer-top {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }

  .footer-left {
    justify-content: center;
  }

  .footer-right {
    align-items: center;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 15px;
    align-items: center;
    text-align: center;
  }

  .qr-item {
    margin: 5px 10px;
  }

  .qr-img {
    width: 50px;
    height: 50px;
  }

  .qr-caption {
    font-size: 11px;
    position: absolute;
    width: 50px
  }

  .b_yb_logo {
    height: 25px;
    width: 120px;
    padding-bottom: 15px;
  }

  .copyright,
  .disclaimer {
    font-size: 11px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  /* 顶部区域 */
  .top-section {
    height: 50px;
    padding: 8px;
  }

  .top-logo {
    height: 20px;
    width: 100px;
  }

  /* 登录表单 */
  .login-form-container {
    width: 95%;
    padding: 18px 20px;
  }

  .login-title {
    font-size: 16px;
    margin-bottom: 15px;
  }

  .form-group {
    margin-bottom: 12px;
  }

  .form-label {
    font-size: 12px;
  }


  .login-button,
  .email-activate-button {
    height: 34px;
    font-size: 12px;
    margin-bottom: 12px;
  }

  .forgot-password,
  .register-link,
  .index_link {
    font-size: 12px;
  }

  /* Footer */
  .footer {
    padding: 15px 0;
  }

  .footer .container {
    padding: 0 3%;
  }

  .footer-top {
    gap: 15px;
  }

  .footer-left {
    gap: 10px;
  }

  .qr-img {
    width: 45px;
    height: 45px;
  }

  .qr-caption {
    font-size: 10px;
  }

  .b_yb_logo {
    height: 20px;
    width: 100px;
    padding-bottom: 10px;
  }

  .copyright,
  .disclaimer {
    font-size: 10px;
    line-height: 1.5;
  }

  .footer-link {
    font-size: 11px;
  }
}

</style>
